import React from "react";
import { Box } from "@mui/material";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export default function PostLoginLoader() {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <DotLottieReact
        src="https://lottie.host/eccdaea1-9b0d-4245-8015-6535a48a55ac/21pW6YReMN.lottie"
        loop
        autoplay
        style={{
          width: "100vw",  
          height: "70vh", 
        }}
      />
    </Box>
  );
}